import InteractionDetailFormsController from "./interaction_detail_forms_controller";

// One expandable entry in the contact page's interactions timeline.
// The header toggles the inline detail; sub-form actions come from the base class.
export default class extends InteractionDetailFormsController {
  static targets = ["body"];

  toggle(event) {
    const expand = this.bodyTarget.hidden;
    this.bodyTarget.hidden = !expand;
    this.element.classList.toggle("contact-detail__timeline-item--open", expand);
    event.currentTarget.setAttribute("aria-expanded", String(expand));
  }

  // "Follow-up of:" reference — expand the parent's entry in the timeline and
  // scroll to it. Falls through to the link's href when the entry isn't on the page.
  openParent(event) {
    const parentId = event.currentTarget.dataset.parentInteractionId;
    const item = document.querySelector(`.contact-detail__timeline-item[data-interaction-id="${parentId}"]`);
    if (!item) return;
    event.preventDefault();

    // The parent may sit behind the "Show all" disclosure in History
    const disclosure = item.closest("details");
    if (disclosure) disclosure.open = true;

    const body = item.querySelector('[data-interaction-entry-target="body"]');
    const toggle = item.querySelector(".contact-detail__timeline-item-toggle");
    if (body) body.hidden = false;
    item.classList.add("contact-detail__timeline-item--open");
    if (toggle) toggle.setAttribute("aria-expanded", "true");

    item.scrollIntoView({ behavior: "smooth", block: "center" });
    item.classList.remove("contact-detail__timeline-item--found");
    void item.offsetWidth; // restart the animation when clicked twice
    item.classList.add("contact-detail__timeline-item--found");
  }
}
